import React, {useEffect,useState} from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { analyticsmanufactureService as service} from '../../../../services';
import CrudEmpty from "../../../crud/CrudEmpty"
import styled from "styled-components";
import { LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Line, ResponsiveContainer, PieChart, Pie, BarChart, Bar } from 'recharts';
import { ToastContainer, toast } from 'react-toastify';
import CustomPaginationActionsTable from '../../../table/Table';
import 'react-toastify/dist/ReactToastify.css';
import Filter from '../../../filter/Filter';
const moment = require("moment");



export default function BrandGeneral() {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterVisit, setFilterVisit] = React.useState({from: moment().add(-30,'days').format("YYYY-MM-DD")+"T00:00:00Z", to:moment().format("YYYY-MM-DD")+"T00:00:00Z", day:true,week:false,month:false});
  const [dataEvolutionVisit, setDataEvolutionVisit] = React.useState<any>([]);
  const [dataEvolutionSearch, setDataEvolutionSearch] = React.useState<any>([]);
  const [dataEvolutionSearchMarket, setDataEvolutionSearchMarket] = React.useState<any>([]);
  const [visitData, setVisitData] = React.useState<any>(null);
  const [visitDataPie, setVisitDataPie] = React.useState<any>([]);
  const [searchData, setSearchData] = React.useState<any>(null);
  const [searchDataPie, setSearchDataPie] = React.useState<any>([]);
  const [searchMarketData, setSearchMarketData] = React.useState<any>(null);
  const [searchDataMarketPie, setSearchDataMarketPie] = React.useState<any>([]);
  const [searchCountryTop10, setSearchCountryTop10] = React.useState<any>([]);
  const [visitCountryTop10, setVisitCountryTop10] = React.useState<any>([]);
  const [visitTop10, setVisitTop10] = React.useState<any>([]);
  const [searchTop10, setSearchTop10] = React.useState<any>([]);
  const [marketTop10, setMarketTop10] = React.useState<any>([]);
  const [searchCountry, setSearchCountry] = React.useState<any>([]);
  const [visitCountry, setVisitCountry] = React.useState<any>([]);
  const [marketCountryTop10, setMarketCountryTop10] = React.useState<any>([]);
  const [marketCountry, setMarketCountry] = React.useState<any>([]);
  const [width, setWidth] = useState<number>(window.innerWidth);

  const createEstructureFilter =  [
    {
        type:"input",
        name: "from",
        inputtype:"date",
        col: 3
    },
    {
        type:"input",
        name: "to",
        inputtype:"date",
        col: 3
    }
];


  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);


  const searchEvolutionVisit = (filterVisit) => {

       if(!filterVisit.from) {
            toast.error(t('brandgeneral.error.from'), {position: toast.POSITION.TOP_CENTER })
       } else if(!filterVisit.to) {
            toast.error(t('brandgeneral.error.to'), {position: toast.POSITION.TOP_CENTER })
       } else {
          let december = moment("2022-12-01");
          let daysDiffStart = moment(filterVisit.from).diff(december, 'days');

          if(daysDiffStart < 0){
            toast.error(t('brandgeneral.error.start'), {position: toast.POSITION.TOP_CENTER })
          } else {
            let daysDiff = moment(filterVisit.to).diff(moment(filterVisit.from), 'days');
            if(daysDiff < 0){
                toast.error(t('brandgeneral.error.diff'), {position: toast.POSITION.TOP_CENTER })
            } else {
                 filterVisit['day'] = daysDiff < 32;
                 filterVisit['week'] = daysDiff >= 32 && daysDiff < 64;
                 filterVisit['month'] = daysDiff >= 64;

                 service.visit(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setDataEvolutionVisit(data.data);
                     }
                 });
 
                 service.search(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setDataEvolutionSearch(data.data);
                     }
                 });
 
 
                 service.searchMarket(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setDataEvolutionSearchMarket(data.data);
                     }
                 });
 
                 service.visitData(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setVisitData(data.data);
                         
                         if(data.data.ranking){
                             let d = [{value:+data.data.total - +data.data.ranking.ammount,name:t("brandgeneral.othersvisit")},{value:+data.data.ranking.ammount, name:t("brandgeneral.youvisit")}];
                             setVisitDataPie(d);
                         }
                     }
                 });
 
 
                 service.searchData(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setSearchData(data.data);
                         
                         if(data.data.ranking){
                             let d = [{value:+data.data.total - +data.data.ranking.ammount,name:t("brandgeneral.otherssearch")},{value:+data.data.ranking.ammount, name:t("brandgeneral.yousearch")}];
                             setSearchDataPie(d);
                         }
                     }
                 });
 
 
                 service.searchMarketData(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setSearchMarketData(data.data);
                         
                         if(data.data.ranking){
                             let d = [{value:+data.data.total - +data.data.ranking.ammount,name:t("brandgeneral.otherssearch")},{value:+data.data.ranking.ammount, name:t("brandgeneral.yousearch")}];
                             setSearchDataMarketPie(d);
                         }
                     }
                 });
 
                 service.serachCountryTop10(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setSearchCountryTop10(data.data);
                     }
                 });
 
                 service.visitCountryTop10(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setVisitCountryTop10(data.data);
                     }
                 });
 
                 service.visitTop10Date(filterVisit, (data, error) => {
                     if(data && data.data) {
                         setVisitTop10(data.data);
                     }
                 });

                 service.searchTop10Date(filterVisit, (data, error) => {
                    if(data && data.data) {
                        setSearchTop10(data.data);
                    }
                });

                 
                service.marketTop10Date(filterVisit, (data, error) => {
                    if(data && data.data) {
                        setMarketTop10(data.data);
                    }
                });
 
                service.visitCountry(filterVisit, (data, error) => {
                    if(data && data.data) {
                        setVisitCountry(data.data);
                    }
                });


                service.serachCountry(filterVisit, (data, error) => {
                    if(data && data.data) {
                        setSearchCountry(data.data);
                    }
                });

                service.visitMarket(filterVisit, (data, error) => {
                    if(data && data.data) {
                        setMarketCountry(data.data);
                    }
                });

                service.visitMarketTop10(filterVisit, (data, error) => {
                    if(data && data.data) {
                        setMarketCountryTop10(data.data);
                    }
                });

          }

           
        }

    }
        
  }

  const searchFilter = (filter) => {
    setFilterVisit(filter);
    searchEvolutionVisit(filter);
  }

  useEffect(() => {
    searchEvolutionVisit(filterVisit);
  }, []);

  const paintvalue = {
    codeCountry: (value) => {
        if (value) {
          return <img src={"/"+value.toLowerCase()+".png"} style={{width:"40px"}} />
        } else {
          return <></>
        }
    },
  }

  return (
    <CrudEmpty i18n={"brandgeneral"}>
        <Grid container style={{background:"white", padding: width > 767?"0.3em 1em 1em":"0.3em 0.2em 1em", borderRadius: "3px", minHeight: "calc(100vh - 250px)", maxWidth:"100%", paddingTop:"1.2em"}}>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <Filter t={t} i18n={"brandgeneral"} searchFilter={searchFilter} filter={filterVisit} titlebutton={t("brandgeneral.titlebutton")} estructure={createEstructureFilter}  hiddenButton={true} expanded={true} isHiddenCancel={true}/> 
        </Grid>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.top.visit")}</h3>
                    <h6>{t("brandgeneral.top.visitsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={visitTop10} fields={["manufacture","ammount","ranking"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}}  moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={3} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.ranking.visit")}</h3>
                    <h6>{t("brandgeneral.ranking.visitsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            <span>{t('brandgeneral.rankingposition')}</span>
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            {visitData && visitData.ranking && visitData.ranking.ranking && <b>{visitData.ranking.ranking}</b>}
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            <span>{t('brandgeneral.visittotal')} </span>
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            {visitData && visitData.ranking && visitData.ranking.ammount && <b>{visitData.ranking.ammount}</b>}
                        </Grid>

                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                        {visitDataPie && visitDataPie.length > 0 &&    <ResponsiveContainer aspect={ width> 767 ? 1.2 : 1.0}  width='100%'>
                                    <PieChart>
                                        <Tooltip />
                                        <Legend />
                                        <Pie data={visitDataPie} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d"  label/>
                                    </PieChart>
                                </ResponsiveContainer> }
                        </Grid>
                            
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={9} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.evolution.title")}</h3>
                    <h6>{t("brandgeneral.evolution.subtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            {dataEvolutionVisit && dataEvolutionVisit.length > 0 && 
                                <ResponsiveContainer aspect={ width> 767 ? 4.0 : 1.5}  width='100%'>
                                    <LineChart data={dataEvolutionVisit}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="dateLabel" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line dataKey="ammount" stroke="#82ca9d" name={t('brandgeneral.visit')}/>
                                    </LineChart>
                                </ResponsiveContainer>}
                        </Grid>
                        <Grid item xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
                            {dataEvolutionVisit && dataEvolutionVisit.length > 0 && 
                                <ResponsiveContainer  aspect={ width> 767 ? 4.0 : 1.5} width='100%'>
                                    <LineChart data={dataEvolutionVisit}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="dateLabel" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line dataKey="ranking" stroke="#8884d8" name={t('brandgeneral.rankingposition')}/>
                                    </LineChart>
                                </ResponsiveContainer>}
                        </Grid>
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.ranking.visitdata")}</h3>
                    <h6>{t("brandgeneral.ranking.visitsubtitledata")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                                <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={dataEvolutionVisit} fields={["dateLabel","ammount","ranking"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}}  moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>
        
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.top.search")}</h3>
                    <h6>{t("brandgeneral.top.searchsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={searchTop10} fields={["manufacture","ammount","ranking"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}}  moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={3} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768} >
                    <h3>{t("brandgeneral.ranking.search")}</h3>
                    <h6>{t("brandgeneral.ranking.searchsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            <span>{t('brandgeneral.rankingposition')}</span>
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            {searchData && searchData.ranking && searchData.ranking.ranking && <b>{searchData.ranking.ranking}</b>}
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            <span>{t('brandgeneral.searchtotal')} </span>
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            {searchData && searchData.ranking && searchData.ranking.ammount && <b>{searchData.ranking.ammount}</b>}
                        </Grid>

                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em",}}>
                        {searchDataPie && searchDataPie.length > 0 &&    <ResponsiveContainer aspect={ width> 767 ? 1.2 : 1.0}  width='100%'>
                                    <PieChart>
                                        <Tooltip />
                                        <Legend />
                                        <Pie data={searchDataPie} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d"  label/>
                                    </PieChart>
                                </ResponsiveContainer> }
                        </Grid>
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={9} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.evolutionsearch.title")}</h3>
                    <h6>{t("brandgeneral.evolutionsearch.subtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            {dataEvolutionSearch && dataEvolutionSearch.length > 0 && 
                                <ResponsiveContainer aspect={ width> 767 ? 4.0 : 1.5}  width='100%'>
                                    <LineChart data={dataEvolutionSearch}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="dateLabel" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line dataKey="ammount" stroke="#82ca9d" name={t('brandgeneral.search')}/>
                                    </LineChart>
                                </ResponsiveContainer>}
                        </Grid>
                        <Grid item xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
                            {dataEvolutionSearch && dataEvolutionSearch.length > 0 && 
                                <ResponsiveContainer  aspect={ width> 767 ? 4.0 : 1.5} width='100%'>
                                    <LineChart data={dataEvolutionSearch}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="dateLabel" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line dataKey="ranking" stroke="#8884d8" name={t('brandgeneral.rankingposition')}/>
                                    </LineChart>
                                </ResponsiveContainer>}
                        </Grid>
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.ranking.searchdata")}</h3>
                    <h6>{t("brandgeneral.ranking.searchsubtitledata")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                                <CustomPaginationActionsTable hiddenpagination={true} t={t} i18n={"brandgeneral"}  rows={dataEvolutionSearch} fields={["dateLabel","ammount","ranking"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}}  moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>
        
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.top.market")}</h3>
                    <h6>{t("brandgeneral.top.marketsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={marketTop10} fields={["manufacture","ammount","ranking"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}}  moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={3} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.ranking.market")}</h3>
                    <h6>{t("brandgeneral.ranking.marketsubtitle")}</h6>
                    <Grid container>
                    <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            <span>{t('brandgeneral.rankingposition')}</span>
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            {searchMarketData && searchMarketData.ranking && searchMarketData.ranking.ranking && <b>{searchMarketData.ranking.ranking}</b>}
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            <span>{t('brandgeneral.searchtotal')} </span>
                        </Grid>
                        <Grid item xs={6} style={{marginTop:"30px", padding:"0.2em"}}>
                            {searchMarketData && searchMarketData.ranking && searchMarketData.ranking.ammount && <b>{searchMarketData.ranking.ammount}</b>}
                        </Grid>

                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                        {searchDataMarketPie && searchDataMarketPie.length > 0 &&   <ResponsiveContainer aspect={ width> 767 ? 1.2 : 1.0}  width='100%'>
                                    <PieChart>
                                        <Tooltip />
                                        <Legend />
                                        <Pie data={searchDataMarketPie} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d"  label/>
                                    </PieChart>
                                </ResponsiveContainer> }
                        </Grid>
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={9} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.evolutionmarket.title")}</h3>
                    <h6>{t("brandgeneral.evolutionmarket.subtitle")}</h6>
                    <Grid container>
                    <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            {dataEvolutionSearchMarket && dataEvolutionSearchMarket.length > 0 && 
                                <ResponsiveContainer aspect={ width> 767 ? 4.0 : 1.5}  width='100%'>
                                    <LineChart data={dataEvolutionSearchMarket}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="dateLabel" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line dataKey="ammount" stroke="#82ca9d" name={t('brandgeneral.search')}/>
                                    </LineChart>
                                </ResponsiveContainer>}
                        </Grid>
                        <Grid item xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
                            {dataEvolutionSearchMarket && dataEvolutionSearchMarket.length > 0 && 
                                <ResponsiveContainer  aspect={ width> 767 ? 4.0 : 1.5} width='100%'>
                                    <LineChart data={dataEvolutionSearchMarket}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="dateLabel" />
                                            <YAxis />
                                            <Tooltip />
                                            <Legend />
                                            <Line dataKey="ranking" stroke="#8884d8" name={t('brandgeneral.rankingposition')}/>
                                    </LineChart>
                                </ResponsiveContainer>}
                        </Grid>
                    </Grid>
            </PanelRounded> 
        </Grid>

        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.ranking.marketdata")}</h3>
                    <h6>{t("brandgeneral.ranking.marketsubtitledata")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                                <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={dataEvolutionSearchMarket} fields={["dateLabel","ammount","ranking"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}}  moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>

        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.country.visit")}</h3>
                    <h6>{t("brandgeneral.country.visitsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                        {visitCountryTop10 && visitCountryTop10.length > 0 && <ResponsiveContainer  aspect={ width> 767 ? 4.0 : 1.5} width='100%'>
                                <BarChart data={visitCountryTop10}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="country" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="ammount" fill="#82ca9d" name={t('brandgeneral.numsearch')} />
                                </BarChart>
                            </ResponsiveContainer> }
                        </Grid>
                            
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.country.visitdata")}</h3>
                    <h6>{t("brandgeneral.country.visitsubtitledata")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                             <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={visitCountry} fields={["codeCountry","country","ammount"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}} paintvalue={paintvalue} moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.country.search")}</h3>
                    <h6>{t("brandgeneral.country.searchsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            {searchCountryTop10 && searchCountryTop10.length > 0 && <ResponsiveContainer  aspect={ width> 767 ? 4.0 : 1.5} width='100%'>
                                <BarChart data={searchCountryTop10}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="country" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="ammount" fill="#82ca9d" name={t('brandgeneral.numsearch')} />
                                </BarChart>
                            </ResponsiveContainer> }
                        </Grid>
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.country.searchdata")}</h3>
                    <h6>{t("brandgeneral.country.searchsubtitledata")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                             <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={searchCountry} fields={["codeCountry","country","ammount"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}} paintvalue={paintvalue} moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>


        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.country.market")}</h3>
                    <h6>{t("brandgeneral.country.marketsubtitle")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                            {marketCountryTop10 && marketCountryTop10.length > 0 && <ResponsiveContainer  aspect={ width> 767 ? 4.0 : 1.5} width='100%'>
                                <BarChart data={marketCountryTop10}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="country" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="ammount" fill="#82ca9d" name={t('brandgeneral.numsearch')} />
                                </BarChart>
                            </ResponsiveContainer> }
                        </Grid>
                    </Grid>
            </PanelRounded> 
        </Grid>
        <Grid item sm={12} xs={12} style={{marginTop:"10px", padding:"0.2em"}}>
            <PanelRounded mobile={width < 768}>
                    <h3>{t("brandgeneral.country.marketdata")}</h3>
                    <h6>{t("brandgeneral.country.marketsubtitledata")}</h6>
                    <Grid container>
                        <Grid item xs={12} style={{marginTop:"30px", padding:"0.2em"}}>
                             <CustomPaginationActionsTable hiddenpagination={true}  t={t} i18n={"brandgeneral"}  rows={marketCountry} fields={["codeCountry","country","ammount"]} fieldId={"id"} rowsPerPage={10} rowsTotal={dataEvolutionVisit.length} deleteaction={false} editable={false} paintCell={{}} paintvalue={paintvalue} moreActions={[]}  />
                        </Grid> 
                    </Grid>
            </PanelRounded> 
        </Grid>

        </Grid>

        <ToastContainer />
    </CrudEmpty>
  );
}


const PanelRounded = styled.div(props => ({
    display: 'block',
    padding: props.mobile? '1em 0.2em' : '1em',
    position: 'relative',
    border: '1px solid #ccc',
    borderRadius: '3px',
    minHeight:"80px",
    "& h3":{
        color: "black",
        position: "absolute",
        fontSize: "1em",
        top: "-2em",
        left: "2em",
        background: "white",
        padding: "0.2em 1em",
        display: "inline-block",

    },
    "& h6": {
        color: "#434343",
        position: "absolute",
        top: "-1.2em",
        fontSize:"0.8em",
        left: "3.5em",
        fontStyle:"italic",
        background: "white",
        padding: "0.2em 1em",
        display: "inline-block",
    }

  }));